import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import CountryDetails from "./CountryDetails";
import Faqs from "./users/Faqs";
import Meeting from "./users/Meeting";
import ParticipateCountry from "./users/ParticipateCountry";
import SlotBooking from "./users/SlotBooking";
import ContactTable from "../../../../components/b2b/ContactTable";

const UsesReqTrack = () => {
    const [activeTab, setActiveTab] = useState("Participate FAQ");
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedSlots, setSelectedSlots] = useState([]);

    const handleCountrySelect = (country) => {
        setSelectedCountry(country);
        setActiveTab("Country Details");
    };

    const handleSlotSelection = (slots) => {
        setSelectedSlots(slots);
    };


    const handleSlotRemove = (slotId) => {
        const updatedSlots = selectedSlots.filter(slot => slot.slotId !== slotId);
        setSelectedSlots(updatedSlots);
    };


    const tabs = ["Participate FAQ", "Participating countries", "Slot & Payment", "Meetings"];

    return (
        <div>
            <div className='pt-2 px-3 fw-semibold'>
                <p><span className="fw-bold">Virtual B2B Forum</span> taking care of your business:</p>
                <ul>
                    <li>Offers A-to-Z solutions of your trade needs.</li>
                    <li>Focus on getting the positive outcomes for our members.</li>
                    <li>Always working together as a team.</li>
                    <li>Securing the business opportunities for both parties.</li>
                </ul>
            </div>
            <hr className='p-0 m-0' />
            <Nav
                variant="pills"
                activeKey={activeTab}
                onSelect={(selectedKey) => setActiveTab(selectedKey)}
                style={{ display: "flex", width: "100%" }}>

                {tabs.map((tab) => (
                    <Nav.Item key={tab} style={{ flex: 1, textAlign: "center" }}>
                        <Nav.Link
                            eventKey={tab}
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                borderRadius: 0,
                                padding: "10px 0",
                                backgroundColor: activeTab === tab ? "blue" : "#f4f4f9",
                                color: activeTab === tab ? "white" : "black"
                            }}>
                            {tab.charAt(0).toUpperCase() + tab.slice(1)}
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>
            <hr className='p-0 m-0' />
            <div className='py-2 px-3 border mt-3'>
                {activeTab === "Participate FAQ" && <Faqs />}
                {activeTab === "Participating countries" && (
                    <ParticipateCountry
                        onCountrySelect={handleCountrySelect}
                        onSlotSelect={handleSlotSelection}
                        selectedSlots={selectedSlots}
                        setActiveGlobalTab={setActiveTab}
                    />
                )}
                {activeTab === "Slot & Payment" && <SlotBooking
                    selectedSlots={selectedSlots}
                    setActiveGlobalTab={setActiveTab}
                    onSlotRemove={handleSlotRemove}
                />}
                {activeTab === "Meetings" && <Meeting />}
                {activeTab === "Country Details" && selectedCountry && (
                    <CountryDetails country={selectedCountry} setActiveGlobalTab={setActiveTab} />
                )}
            </div>
            <div className='py-2 px-3 border mt-3'>
                <p className="fw-semibold text-danger">
                    <span className="fw-bold">Note:</span><br />Before proceeding with participation, please read the FAQs carefully. Ensure that all required details are correctly provided, verify the available slots, and confirm your participation. Any incomplete or incorrect information may lead to delays in processing your registration.
                </p>
            </div>
            <div style={{ marginTop: "20px" }}>
                <ContactTable />
            </div>

        </div>
    );
};

export default UsesReqTrack;
